import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=849a31c4&scoped=true"
import script from "./AccountInfo.vue?vue&type=script&lang=js"
export * from "./AccountInfo.vue?vue&type=script&lang=js"
import style0 from "./AccountInfo.vue?vue&type=style&index=0&id=849a31c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849a31c4",
  null
  
)

export default component.exports